// extracted by mini-css-extract-plugin
export default {"list":"list--af8301","item":"item--d8d1c7"};